import { useFetchUpcomingScheduledEvent } from '@/api/hooks/useFetchUpcomingScheduledEvent'
import { SchedulingActions } from '@/components/HomePage/ScheduleActions'
import { UpcomingAppointment } from '@/components/HomePage/UpcomingAppointment'
import { UpcomingVrdhCall } from '@/components/HomePage/UpcomingVrdhCall'

import { Skeleton } from '@/ui/core/skeleton'
import { VStack } from '@/ui/core/stack'

const PatientActionsCta = () => {
	const {
		scheduledEvent,
		isLoading,
		hasScheduledAppointment,
		hasScheduledVrdhCall,
		hasNoScheduledEvents,
	} = useFetchUpcomingScheduledEvent()

	return (
		<VStack gap={32} className="flex-1 justify-center items-center md:bg-white">
			<Skeleton isLoading={isLoading} className={'h-12 w-3/5 max-w-60'}>
				{hasScheduledAppointment && (
					<UpcomingAppointment appointment={scheduledEvent.appointment!} />
				)}
				{hasScheduledVrdhCall && <UpcomingVrdhCall vrdhCall={scheduledEvent.vrdhCall!} />}
				{hasNoScheduledEvents && <SchedulingActions />}
			</Skeleton>
		</VStack>
	)
}

export { PatientActionsCta }
